import { SearchTab } from '@habity/types';
import { useFilters } from './useFilters';
import { useGeolocation } from './useGeolocation';

/**
 * Hook for handling location-based search functionality
 * Uses the useGeolocation hook for location fetching and updates search filters
 */
export const useLocationSearch = () => {
  const { performSearch } = useFilters();
  const { isLoading, getCurrentLocation } = useGeolocation();

  /**
   * Get the user's current location and update search filters
   * @param tab The tab to search in
   * @param options Optional configuration for the search
   */
  const searchByCurrentLocation = (tab?: SearchTab, options?: { 
    onSuccess?: (position: GeolocationPosition) => void,
    onError?: (error: GeolocationPositionError) => void
  }) => {
    
    // Use the geolocation hook to get the current location
    getCurrentLocation({
      onSuccess: (position) => {
        const { latitude, longitude } = position.coords;
        
        // Perform search with location coordinates
        // performSearch will handle updating the filters in the store
        performSearch({ 
          filters: {
            longitude,
            latitude,
          },
          tab 
        });
        
        // Call the original onSuccess if provided
        if (options?.onSuccess) {
          options.onSuccess(position);
        }
      },
      onError: options?.onError
    });
  };

  return {
    isLoading,
    searchByCurrentLocation
  };
};
